import { isDealKnotsAllowedForRole } from './knotTabAccess';

export const PRODUCT_ACCESS_DENY_MSG =
    'You are not authorized to view this transaction. If you believe this is a mistake, contact your administrator.';

export const BROKER_TSP_UNAVAILABLE_MSG =
    'Trade Support Program is not available on the Broker platform.';

export const productForTransactionType = (type) =>
    type === 'deal_financing' || type === 'payable' ? 'deal' : 'trade';

export const normalizeTransactionType = (type) => {
    if (type === 'payable') return 'deal_financing';
    if (type === 'marketPlace' || type === 'marketplace') return 'marketplace';
    return type || '';
};

/** IAM GET only — fail-closed (ok + enabled). */
export const iamProductEnabled = (flags, product) => {
    const key = product === 'deal' ? 'deal' : 'trade';
    return flags?.[key]?.ok === true && flags[key].enabled === true;
};

/** Pre-fetch gate for /transactions/:id. */
export const resolveTransactionAccessGate = ({
    isProductGatedRole,
    flagsLoaded,
    flags,
    hintedType,
    platformRole,
}) => {
    if (!isProductGatedRole) {
        return { status: 'allowed', txnType: hintedType || '', message: '' };
    }
    if (!flagsLoaded) {
        return { status: 'pending', txnType: '', message: '' };
    }

    const trade = iamProductEnabled(flags, 'trade');
    const deal = isDealKnotsAllowedForRole(platformRole) && iamProductEnabled(flags, 'deal');

    if (!trade && !deal) {
        return { status: 'denied', txnType: '', message: PRODUCT_ACCESS_DENY_MSG };
    }

    if (hintedType) {
        const product = productForTransactionType(hintedType);
        if (!(product === 'deal' ? deal : trade)) {
            if (product === 'deal' && !isDealKnotsAllowedForRole(platformRole)) {
                return { status: 'denied', txnType: '', message: BROKER_TSP_UNAVAILABLE_MSG };
            }
            const label = product === 'deal' ? 'Trade Support Program' : 'BAAS';
            return {
                status: 'denied',
                txnType: '',
                message: `${label} is not enabled for this organization. If you believe this is a mistake, contact your administrator.`,
            };
        }
        return { status: 'allowed', txnType: hintedType, message: '' };
    }

    // No type in nav: allow only when Trade is ON (marketplace). Deal deep links need type in state.
    if (!trade) {
        return {
            status: 'denied',
            txnType: '',
            message:
                'Trade Support Program is not enabled for this organization. Open Trade Support Program transactions from the Trade Support Program dashboard.',
        };
    }

    return { status: 'allowed', txnType: 'marketplace', message: '' };
};

export const isAccessDeniedApiError = (err) => {
    if (!err) return false;
    const status = err?.status ?? err?.responseCode ?? err?.response?.status;
    const message = err?.serviceMessage || err?.message || '';
    return status === 403 || /access denied/i.test(message);
};
